import styled from '@emotion/styled';
import { CasinoCherryIcon } from 'src/ui/assets/icons/casino/CasinoCherryIcon';
import { CloseIcon } from 'src/ui/assets/icons/other/CloseIcon';
import { Button } from 'src/ui/components/button/common/Button';
import { withConfig } from 'src/withConfig';

export const HeaderWrapper = withConfig(theme => styled('header', { label: 'HeaderWrapper' })`
    align-items: center;
    color: ${theme.star.casino.casinoMini.colors.txtPrimary};
    display: flex;
    flex: 0 0 40px;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 4px;
    justify-content: start;
    line-height: ${theme.star.lineHeight[200]};
    padding: 8px;
    @media ${theme.star.mediaQuery.desktop} {
        color: ${theme.star.casino.casinoMini.colors.txtSecondary};
        margin: -8px -8px 0;
        padding: 10px 8px;
    }
`);

export const CasinoIconBox = withConfig(theme => styled(CasinoCherryIcon, { label: 'CasinoIconBox' })`
    color: ${theme.star.casino.casinoMini.colors.bgSecondary};
    flex: 0 0 20px;
    width: 20px;
    @media ${theme.star.mediaQuery.desktop} {
        color: ${theme.star.casino.casinoMini.colors.bgQuaternary};
    }
`);

export const HeaderTitle = styled('h4', { label: 'HeaderTitle' })`
    margin: 0;
`;

export const PlayNowButton = styled(Button, { label: 'PlayNowButton' })`
    margin-left: auto;
`;

export const CloseWidgetIcon = styled(CloseIcon, { label: 'CloseWidgetIcon' })`
    cursor: pointer;
    margin-left: auto;
    padding: 4px;
`;
